<template><div><h1>VUX V2.7.7 released</h1>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] remove the first top line #2371</li>
</ul>
<h2><a href="/en/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] Fix the problem of inaccurate positioning and invalid positioning 0 #2367</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] fix cannot scroll body when touching with one item</li>
</ul>
<h2><a href="/en/components/tabbar.html">Tabbar</a></h2>
<ul><li>[fix] fix tabbar-item ssr rendering issue</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[fix] plugin options is used as toast default options</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[fix] Fix error message not change bugs #2348</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.7 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.7-145.vue?fd0dd808